import { getCurrentUserEmail, getLoggedInUserName } from "./auth";
import { getUserNameFromEmail } from "./email";

export const getAuthContextForLibs = () => {
  const email = getCurrentUserEmail();
  const username = getLoggedInUserName() || getUserNameFromEmail(email);

  return {
    username,
    email,
  };
};
